import React, { useEffect } from 'react'
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { employee, salariesSlice, salariesState } from './SalariesSlice'


// Stylesheet
import './Salaries.css'

// Components
import {  NumberField } from '../../../components/FormElements/FormElements'
import { EllipsisLoader, SuccessMark, WhiteboxLoader } from '../../../components/Loader/Loader'
import Modal from '../../../components/Modal/Modal'

import { useAPI } from '../../../services/hoc/useAPI'

export default () => {

    // Translation
    const t = useTranslation()

    // Redux
    const dispatch = useDispatch()
    const state = useSelector( ( state: { salaries: salariesState } ) => state.salaries )

  const ENDPOINTS = useAPI()

    // Save data
    const save = ( e: React.FormEvent<HTMLFormElement> ) => {
        
        e.preventDefault()

        dispatch( salariesSlice.actions.setIsLoading(true) )

        let firstDayOfMonth = new Date()
        firstDayOfMonth = new Date(firstDayOfMonth.getFullYear(), firstDayOfMonth.getMonth(), 2)
        let date: string = firstDayOfMonth.toISOString().substr(0,10).replace(/-/g, "/")

        ENDPOINTS.salaries().store({
            salaries: state.employees.map(employee => ({
                ...employee,
                employee_id: employee.id,
                date
            }))
        })
        .then((response: any) => {
            dispatch( salariesSlice.actions.setIsSuccess(true) )
            setTimeout(() => {
                dispatch( salariesSlice.actions.close() )
            }, 1000);
        })

    }

    const fetchData = () => {

        ENDPOINTS.employees().index({ page: 1, page_size: 1000 })
        .then((response: any) => {
            let employees: employee[] = []
        response.data.data?.employees?.map((employee: any) => {
                employees.push({
                    id: employee.id,
                    name: employee.name,
                    salary: Number(employee.salary),
                    absence_time: 0,
                    additional_time: 0,
                    additional_value: 0,
                    discount_value: 0,
                    net_salary: Number(employee.salary)
                })
                dispatch( salariesSlice.actions.addEmployees(employees) )
            })
          

            ENDPOINTS.salaries().index({ page: 1, page_size: 1000 })
            .then((response: any) => {
                dispatch( salariesSlice.actions.updateDefaultSalaries(response.data.data?.salaries?.map((salary: any) => ({
                    id: Number(salary.employee_id),
                    salary: Number(salary.salary),
                    additional_time: Number(salary.additional_time),
                    additional_value: Number(salary.additional_value),
                    absence_time: Number(salary.absence_time),
                    discount_value: Number(salary.discount_value),
                    net_salary: Number(salary.net_salary)
                }))) )
            })

        })

    }
    
    // First fetch
    useEffect(() => {
        if( state.isOpen )
            fetchData()
    }, [state.isOpen])

    return(
        <>
            <Modal open={state.isOpen} toggle={() => dispatch( salariesSlice.actions.setIsOpen(false) )}>
            { state.isLoaded ?
            <>
                { state.isLoading ? <WhiteboxLoader /> : ""}
                { state.isSuccess ? <SuccessMark /> : ""}
                <h2 className="text-center" style={{ margin: "0 0 20px" }}>{t("monthly_salaries")}</h2>
                <form onSubmit={save} style={{ width: 1000, maxWidth: "100%" }}>
                    <table className="salaries">
                        { state.employees.map((employee, index) => (
                            <tr key={"saslary-" + index}>
                                <td>#{index + 1}</td>
                                <td>
                                    <ul className="tags">
                                        <li>{employee.name}</li>
                                    </ul>
                                </td>
                                <td>
                                    <NumberField
                                        value={employee.salary}
                                        label={t("salary")}
                                        disabled />
                                </td>
                                <td>
                                    <NumberField
                                        value={employee.additional_time}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                            let additional_time = Number(e.target.value)
                                            let net_salary = (employee.net_salary || 0) + (additional_time - (employee.additional_time || 0)) * (employee.additional_value || 0)
                                            dispatch( salariesSlice.actions.updateEmployee({ index, employee: { additional_time, net_salary } }) )
                                        }}
                                        label={t("additional_hours")} />
                                </td>
                                <td>
                                    <NumberField
                                        value={employee.additional_value}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                            let additional_value = Number(e.target.value)
                                            let net_salary = (employee.net_salary || 0) + (additional_value - (employee.additional_value || 0)) * (employee.additional_time || 0)
                                            dispatch( salariesSlice.actions.updateEmployee({ index, employee: { additional_value, net_salary } }) )
                                        }}
                                        label={t("additional_value")} />
                                </td>
                                <td>
                                    <NumberField
                                        value={employee.absence_time}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                            let absence_time = Number(e.target.value)
                                            let net_salary = (employee.net_salary || 0) - (absence_time - (employee.absence_time || 0)) * (employee.discount_value || 0)
                                            dispatch( salariesSlice.actions.updateEmployee({ index, employee: { absence_time, net_salary } }) )
                                        }}
                                        label={t("absence_hours")} />
                                </td>
                                <td>
                                    <NumberField
                                        value={employee.discount_value}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                            let discount_value = Number(e.target.value)
                                            let net_salary = (employee.net_salary || 0) - (discount_value - (employee.discount_value || 0)) * (employee.absence_time || 0)
                                            dispatch( salariesSlice.actions.updateEmployee({ index, employee: { discount_value, net_salary } }) )
                                        }}
                                        label={t("discount_value")} />
                                </td>
                                <td>
                                    <NumberField
                                        value={employee.net_salary}
                                        label={t("net_salary")}
                                        disabled />
                                </td>
                            </tr>
                        )) }
                    </table>

                    <button className="button round bg-gold color-white margin-top-30" style={{ padding: "0 80px", marginBottom: 5 }}>{t("save")}</button>
                </form>
            </> : <div className="center"><EllipsisLoader /></div> }
            </Modal>
        </>
    )

}